import { Inject, Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { KpiTrendModuleData, KPIWidgetSparkGraph } from './extended-kpi.model';

@Injectable({
	providedIn: 'root'
})
export class ExtendedKpiService {

	constructor(
		private cvApiService: CVApiService,
	) { }

	public async loadKPIData(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false) {
		try {
			let renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
			let response = await this.cvApiService.get<KpiTrendModuleData>(`/api/v2/dashboards/modules/kpi/${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`, renderEndpoint);
			if (response.status_code >= 200 && response.status_code < 300)
				return response.data;
			else throw response;
		} catch (err) {
			console.error("Failed getting data for extended kpi module.");
			throw err;
		}
	};

	public async loadKPIGraph(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false) {
        try {
            let renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            let response = await this.cvApiService.get<KPIWidgetSparkGraph[]>(`/api/v2/dashboards/modules/kpi-graph/${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed getting graph data for extended kpi module.");
            throw err;
        }
    }

	public async getDataForExport(moduleKey: string, format: string) {
        let renderEndpoint: string;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        } catch (err) {
            console.error("Failed getting render endpoint.");
            throw err;
        }
        
        const url = `/api/v2/dashboards/modules/kpi/${moduleKey}/export?format=${format}`;
        try {
            let response = await this.cvApiService.get<string>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        } catch (err) {
            console.error("Failed getting KPI Trends Data for Export.");
            throw err;
        }
    }
}
